import React from 'react';
import PropTypes from 'prop-types';
import { RenderRadioField } from '@zola/zola-ui/src/components/Form/RenderRadioField';
import classNames from 'classnames';

// eslint-disable-next-line import/prefer-default-export
export const FilterRadio = ({ value, label, selectedSortValue, onChange }) => {
  const isActive = value === selectedSortValue;
  const checkboxBorderClassName = classNames('checkbox-list__section', {
    'checkbox-list__section--active': isActive,
  });

  return (
    <RenderRadioField
      className={checkboxBorderClassName}
      label={label}
      type="radio"
      id={value}
      input={{
        name: value,
        checked: isActive,
        onChange,
      }}
      meta={{ touched: true }}
    />
  );
};

FilterRadio.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  selectedSortValue: PropTypes.string,
};
